<script lang="ts" setup>
import { ref, watch } from "vue";
import PoolsList from "@/features/pools/PoolsList.vue";
import KlereoIcon from "@/shared/components/KlereoIcon.vue";
import config from "@/config";
import { useRoute } from "vue-router";
import { useBrowse } from "@/shared/mixins/useLink";

const emit = defineEmits(["close"]);

const links = ref([
  { icon: "user", title: "MyInfos", target: "/profile" },
  { icon: "align-left", title: "Messages", target: "/notes" },
  // { icon: "bell", title: "Mes notifications" },
  // { icon: "chart-blue", title: "Statistiques globales" },
  { icon: "map-pin", title: "PoolMap", target: "/map" },
  {
    icon: "maximize",
    title: "PACDim",
    external: true,
    target: "/v1/?page=calc-pac",
  },
  {
    icon: "grid",
    title: "EspPro",
    external: true,
    target: "/v2/espace/pro/home",
  },
  {
    icon: "grid",
    title: "MyAppLink",
    external: true,
    target: "/v1/?page=app",
  },
  { icon: "grid", title: "Logout", target: "/logout" },
]);

const showMenu = ref(false);

const route = useRoute();
watch(route, () => {
  emit("close");
});

const externalLinksRoot = config.externalLinksRoot;

const browse = useBrowse();
</script>

<template>
  <div class="sidebar flex flex-col h-full overflow-hidden">
    <div class="flex justify-between">
      <img src="@/assets/images/logo.svg" alt="Klereo" @click="emit('close')" />
      <klereo-icon
        name="x-circle"
        class="mr-5 cursor-pointer lg:hidden"
        @click="emit('close')"
      />
    </div>

    <div class="overflow-auto grow shrink">
      <pools-list class="relative shrink" @pool-click="emit('close')" />
    </div>

    <div class="border-t mt-2 py-2">
      <h3
        class="text-sm text-white flex items-center mb-1 cursor-pointer"
        @click="showMenu = !showMenu"
      >
        <klereo-icon
          name="chevron-down"
          class="transition-transform mr-1"
          :class="{ '-rotate-90': !showMenu }"
        />
        {{ $t("Menu") }}
      </h3>

      <div
        class="overflow-hidden transition-[max-height]"
        :class="showMenu ? 'max-h-[500px]' : 'max-h-0'"
      >
        <ul class="mx-5 my-3 text-white text-sm">
          <li
            v-for="link in links"
            :key="link.title"
            class="mb-3 cursor-pointer"
          >
            <component
              :is="link.external ? 'a' : 'router-link'"
              v-bind="{
                [link.external ? '' : 'to']: link.external ? '' : link.target,
              }"
              @click="
                link.external &&
                  browse({ url: externalLinksRoot + link.target })
              "
            >
              <klereo-icon :name="link.icon" class="inline-block mr-2" />
              {{ $t(link.title) }}
            </component>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
